import DatePicker from "components/input-types/DatePicker";
import { useSelector } from "react-redux";
import { selectForm } from "reducers";
import dayjs from "dayjs";

const ProjectEndDate = (props) => {
	const form = useSelector(selectForm);
	const createOnString = form?.createOn
		? form.createOn
		: dayjs().format("YYYY-MM-DD");
	const createOn = dayjs(createOnString);

	const disabledDate = (current) => {
		//3 months from form creation date
		return current && current < createOn;
	};
	return <DatePicker {...props} disabledDate={disabledDate} />;
};

export default ProjectEndDate;
